export default __webpack_public_path__ + "static/media/hotel_3.23bd1c74.png";